import { Modal } from '@material-ui/core';
import { DataGrid, GridToolbar, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from '@material-ui/data-grid';
import React, { useEffect, useState } from 'react';
import { configs, downloadDoc, downloadImage } from '../../../assets/Config';
import '../../../assets/styles/RM.css'
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import { useKYCContext } from '../../../services/contexts/KYCContext';
import { useBuyOrderContext } from '../../../services/contexts/BuyOrdersContext';
import MandateModalPage from './MandateModalPage';
import { Link } from 'react-router-dom';


export default function ListMandatePage() {

    const { tableMandateData, setTableMandateData, getAllMandate, setMandateData, activeStatus, setActiveStatus, setRejectMandateModal, setPaymentMandateModal, setAcknowledgeMandateModal, setCompleteMandateModal, setRefundMandateModal, setEditMandate, downloadHDFCSheetByOrderId } = useBuyOrderContext()
    const { allowedFunc } = useLogin()
    const { setKycRequesterUserDetail, setShowError } = useKYCContext();

    const [error, setError] = useState("");
    const [rowsDisplay, setRowsDisplay] = useState(configs.defaultRowPerPage);
    const [page, setPage] = useState(configs.startPage);

    const [selectionModel, setSelectionModel] = useState([]);

    useEffect(() => {
        (async () => {
            setSelectionModel([])

            if (activeStatus && configs.mandateStatusTypes[activeStatus] && page) {
                if (page > configs.startPage) {
                    setPage(configs.startPage)
                }
                else {
                    await getAllMandate(activeStatus === Object.keys(configs.mandateStatusTypes)[1] ? "" : configs.mandateStatusTypes[activeStatus].status, page, configs.recordPerPage, true);
                }
            }
        })()
    }, [activeStatus])

    useEffect(() => {
        (async () => {
            if (activeStatus && configs.mandateStatusTypes[activeStatus] && page)
                await getAllMandate(activeStatus === Object.keys(configs.mandateStatusTypes)[1] ? "" : configs.mandateStatusTypes[activeStatus].status, page, configs.recordPerPage);
        })()
    }, [page])

    useEffect(() => {
        setActiveStatus(Object.keys(configs.mandateStatusTypes)[0])
    }, [])

    const columns = [{ field: "id", headerName: "Mandate ID", minWidth: 100, flex: 0.5, filterable: false },
    {
        field: "company_name", headerName: "Company Name", minWidth: 200, flex: 0.5, cellClassName: "break-text f-12", valueGetter: (params) => {
            return params.row.company.name
        }
    },
    {
        field: "name", headerName: "Name", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12", valueGetter: (params) => {
            return params.row.user.name
        }
    },
    {
        field: "mobile", headerName: "Phone No.", minWidth: 100, flex: 0.3, cellClassName: "break-text f-12", renderCell: (params) => {
            return <a href={"https://wa.me/" + params.row.user.mobile} target="_blank">{params.row.user.mobile ? `+${params.row.user.mobile}` : params.row.user.mobile}</a>
        }, valueGetter: (value) => value.row.user.mobile ? `+${value.row.user.mobile}` : value.row.user.mobile
    },
    {
        field: "email", headerName: "E-mail", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
            if (allowedFunc.includes(configs.functionList['user_management:load_user_details'])) {
                return <Link to={`/customerProfile/${params.row.user.id}`} onClick={() => {
                    setKycRequesterUserDetail(params.row.user)
                }}>{params.row.user.email}</Link>
            } else {
                return params.row.user.email
            }
        }, valueGetter: (value) => value.row.user.email
    },
    {
        field: "rm_email", headerName: "RM Email", hide: true, minWidth: 100, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
            return params.row && params.row.relationship_manager && params.row.relationship_manager.email ? params.row && params.row.relationship_manager && params.row.relationship_manager.email : ""
        }, valueGetter: (params) => params.row && params.row.relationship_manager && params.row.relationship_manager.email ? params.row && params.row.relationship_manager && params.row.relationship_manager.email : ""
    },
    {
        field: "rm_name", headerName: "RM Name", minWidth: 100, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
            return params.row && params.row.relationship_manager && params.row.relationship_manager.name ? params.row && params.row.relationship_manager && params.row.relationship_manager.name : ""
        }, valueGetter: (params) => params.row && params.row.relationship_manager && params.row.relationship_manager.name ? params.row && params.row.relationship_manager && params.row.relationship_manager.name : ""
    },
    {
        field: "deal_done_by", headerName: "Deal Done By", minWidth: 100, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
            return params.row.deal_done_by && params.row.deal_done_by.name ? params.row.deal_done_by.name : ""
        }, valueGetter: (params) => params.row.deal_done_by && params.row.deal_done_by.name ? params.row.deal_done_by.name : ""
    },
    { field: "quantity", headerName: "Quantity", minWidth: 100, flex: 0.5 },
    { field: "price_per_share", headerName: "Price/Share", minWidth: 100, flex: 0.5 },
    { field: "advance_percentage", headerName: "Advance Percentage", minWidth: 100, flex: 0.5 },
    activeStatus === configs.mandateStatusTypes["Acknowledged Mandates"].name || activeStatus === configs.mandateStatusTypes["Refund Initiated"].name || activeStatus === configs.mandateStatusTypes["Acknowledgement Pending"].name ? {
        field: "utr", headerName: "UTR", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => cellValues.row.utrs?.[0]?.utr ?? "", valueGetter: (value) => value.row.utrs?.[0]?.utr ?? ""
    } : "",
    activeStatus === configs.mandateStatusTypes["Acknowledged Mandates"].name || activeStatus === configs.mandateStatusTypes["Refund Initiated"].name || activeStatus === configs.mandateStatusTypes["Acknowledgement Pending"].name ? {
        field: "bank", headerName: "Bank Name", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => cellValues.row.utrs?.[0]?.bank_name ?? "", valueGetter: (value) => value.row.utrs?.[0]?.bank_name ?? ""
    } : "",
    activeStatus === configs.mandateStatusTypes["Acknowledged Mandates"].name || activeStatus === configs.mandateStatusTypes["Refund Initiated"].name || activeStatus === configs.mandateStatusTypes["Acknowledgement Pending"].name ? {
        field: "payment_date", headerName: "Payment Date", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => cellValues.row.utrs?.[0]?.payment_date ?? "", valueGetter: (value) => value.row.utrs?.[0]?.payment_date ?? ""
    } : "",
    // { field: "status", headerName: "Status", minWidth: 100, flex: 0.5, hide: true },
    {
        field: "status", headerName: "Status Message", minWidth: 100, flex: 0.5, renderCell: (cellValues) => {
            return configs.mandateStatusLinks[cellValues.row.status]
        }
    },
    { field: "comment", headerName: "Comment", minWidth: 100, flex: 0.5 },
    { field: "remark", headerName: "Remark", minWidth: 100, flex: 0.5 },
    { field: "token_amount", headerName: "Token Amount", minWidth: 100, flex: 0.5 },
    { field: "mandate_time", headerName: "Mandate Time(days)", minWidth: 100, flex: 0.5 },
    { field: "date", headerName: "Date", minWidth: 100, flex: 0.5 },
    { field: "time", headerName: "Time", minWidth: 100, flex: 0.5 },
    activeStatus === configs.mandateStatusTypes["Payment Pending"].name || activeStatus === configs.mandateStatusTypes["Acknowledgement Pending"].name ? {
        field: "reject", headerName: " ", minWidth: 50, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
            return <a href="#" className="custom-link text-danger" onClick={(e) => {
                e.preventDefault()
                setMandateData(cellValues.row);
                setRejectMandateModal(true);
            }}>Reject</a>
        }
    } : "",
    activeStatus === configs.mandateStatusTypes["Payment Pending"].name ? {
        field: "edit", headerName: " ", minWidth: 50, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
            return <a href="#" className="custom-link text-primary" onClick={(e) => {
                e.preventDefault()
                setMandateData(cellValues.row);
                setEditMandate(true);
                document.getElementById("rmCreateCompany").classList.toggle('d-none')
                document.getElementById("companyListPage").classList.toggle('d-none')
            }}>Edit</a>
        }
    } : "",
    activeStatus === configs.mandateStatusTypes["Payment Pending"].name ? {
        field: "payment", headerName: " ", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
            return <a href="#" className="custom-link" onClick={(e) => {
                e.preventDefault()
                setMandateData(cellValues.row);
                setPaymentMandateModal(true)
            }}>Payment</a>
        }
    } : "",
    activeStatus === configs.mandateStatusTypes["Acknowledgement Pending"].name ? {
        field: "ack_payment", headerName: " ", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
            return <a href="#" className="custom-link" onClick={(e) => {
                e.preventDefault()
                setMandateData(cellValues.row);
                setAcknowledgeMandateModal(true)
            }}>Acknowledge</a>
        }
    } : "",
    activeStatus === configs.mandateStatusTypes["Acknowledged Mandates"].name ? {
        field: "ack_complete", headerName: " ", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
            return <a href="#" className="custom-link" onClick={(e) => {
                e.preventDefault()
                setMandateData(cellValues.row);
                setCompleteMandateModal(true)
            }}>Convert Mandate</a>
        }
    } : "",
    activeStatus === configs.mandateStatusTypes["Refund Initiated"].name ? {
        field: "refund", headerName: " ", minWidth: 100, flex: 0.4, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
            return <a href="#" className="custom-link" onClick={(e) => {
                e.preventDefault()
                setMandateData(cellValues.row);
                setRefundMandateModal(true)
            }}>Complete Refund</a>
        }
    } : ""
    ]

    // download hdfc sheet
    async function exportHDFC() {
        try {
            let ele = document.getElementById('rmContainer').click();
            let response = await downloadHDFCSheetByOrderId(selectionModel, true)
            if (response && response === "success") {
                setSelectionModel([])
            } else {
                setError(response)
                setShowError(true)
            }
        } catch (error) {
            console.error(error)
        }
    }

    // add hdfc export option in export toolbar
    function addHDFCExportButton() {
        try {
            setTimeout(() => {
                // get root element to add element
                let ele = document.getElementsByClassName("MuiList-root MuiDataGrid-gridMenuList MuiList-padding")
                if ((ele.length > 0) && (selectionModel.length > 0) && (activeStatus === configs.shareStatusTypes["Refund Initiated"].name)) {
                    //create new element to add
                    var li = document.createElement('li')
                    li.className = "MuiButtonBase-root MuiListItem-root MuiMenuItem-root MuiMenuItem-gutters MuiListItem-gutters MuiListItem-button";
                    let span = document.createElement('span');
                    span.className = "MuiTouchRipple-root"
                    li.appendChild(document.createTextNode("HDFC Sheet"))
                    li.appendChild(span)
                    li.tabIndex = 0
                    li.setAttribute("role", "menu-item")
                    li.ariaDisabled = "false"
                    li.addEventListener("click", exportHDFC);

                    //add new elemet to parent
                    ele[0].appendChild(li)
                }
            }, 200)
        } catch (error) {
            console.error(error)
        }
    }

    // react data table export option
    function CustomToolbar() {
        try {
            let ele = document.querySelectorAll("[aria-label^='Export']");
            if (ele.length > 0 && activeStatus === configs.shareStatusTypes['Refund Initiated'].name) {

                ele[0].addEventListener("click", addHDFCExportButton)
            }
        } catch (error) {
            console.error(error)
        }
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport csvOptions={{ allColumns: true }} />
            </GridToolbarContainer>
        );
    }

    // list mandate
    return (
        <div id="companyListPage" className='d-md-block' style={{ width: "100%" }}>
            <div className="row d-flex align-items-center mt-2 ml-3 mb-1 mr-2">
                <div className="col-4 m-0 p-0">
                    <p className="h4 text-custom-grey">Mandate Management</p>
                </div>
                <div className='col-4 d-flex align-items-center'>
                    <button id="getAllRecordsBtn" className="btn btn-primary" onClick={async (e) => {
                        e.preventDefault()
                        try {
                            document.getElementById("getAllRecordsBtn").classList.toggle("d-none")
                            document.getElementById("getAllRecordsBtnLoader").classList.toggle("d-none")
                            await getAllMandate(activeStatus === Object.keys(configs.mandateStatusTypes)[1] ? "" : configs.mandateStatusTypes[activeStatus].status, 0, 0, true)
                        } finally {
                            const btn = document.getElementById("getAllRecordsBtn")
                            if (btn && btn.classList.contains("d-none")) {
                                btn.classList.toggle("d-none")
                                document.getElementById("getAllRecordsBtnLoader").classList.toggle("d-none")
                            }
                        }
                    }}>Get All Records</button>
                    <div id="getAllRecordsBtnLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                </div>
                <div className="col-md-4 text-md-right text-left m-0 p-0">
                    <span className="text-primary mr-2">Status</span>
                    <select name="" id="" className=" py-1 px-2 border rounded" value={activeStatus ? activeStatus : ""} onChange={(e) => {
                        setTableMandateData("")
                        setActiveStatus(e.target.value)
                    }}>
                        {Object.keys(configs.mandateStatusTypes).map((element, key) => {
                            if (allowedFunc.includes(configs.mandateStatusTypes[element].functionName)) {
                                return (
                                    <option key={`shareStatusKey` + key} value={configs.mandateStatusTypes[element].name}>{configs.mandateStatusTypes[element].name}</option>
                                )
                            } else {
                                return null
                            }
                        })}
                    </select>
                </div>

            </div>
            <div className='row m-0 mx-3 p-0 d-md-none d-block'>
                <a href='#' className='custom-link' onClick={(e) => {
                    e.preventDefault()
                    document.getElementById("rmCreateCompany").classList.toggle('d-none')
                    document.getElementById("companyListPage").classList.toggle('d-none')
                }}><p className='m-0 p-0'>Create New Mandate</p></a>
            </div>
            {tableMandateData ?
                <div className="nm-role-table m-2">
                    <DataGrid
                        rows={tableMandateData}
                        headerHeight={30}
                        rowHeight={40}
                        columns={columns}
                        resizable={true}
                        pageSize={rowsDisplay}
                        pagination
                        onPageChange={(currenIndex) => {
                            if ((currenIndex + 1) === Math.ceil(tableMandateData.length / rowsDisplay)) {
                                setPage(page + 1);
                            }
                        }}
                        onPageSizeChange={(rowsBeingDisplayed) => {
                            setRowsDisplay(rowsBeingDisplayed);
                        }}
                        checkboxSelection={activeStatus === configs.shareStatusTypes['Refund Initiated'].name ? true : false}
                        onSelectionModelChange={(newSelectionModel) => {
                            if (activeStatus === configs.shareStatusTypes['Refund Initiated'].name) {
                                setSelectionModel(newSelectionModel);
                                let ele = document.getElementById('rmContainer').click();
                            }
                        }}
                        selectionModel={activeStatus === configs.shareStatusTypes['Refund Initiated'].name ? selectionModel : []}
                        components={{
                            Toolbar: CustomToolbar,
                        }}
                    />
                </div>
                : <div className="loader"></div>}
            <MandateModalPage />
        </div>
    )
}